import "./Login.scss"
import { useState } from "react";
import { login } from "../../ApiInterface";

const Login = () => {
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null as string | null)
    const onSubmit = (e: any) => {
        setErrorMessage(null)
        setLoading(true)
        const data = new FormData(e.target) as any;
        const {email, password} = Object.fromEntries([...data.entries()])
        e.preventDefault()
        e.stopPropagation()
        login({email, password})
            .then((a) => {
                window.location.href = "/"
            })
            .catch((error) => {
                setErrorMessage(error?.response?.data?.error_message || 'Unknown error')
                setLoading(false)
            })
            
    }

    return <div className="login-container">
        <div className="login-hero">
            <div className="login-pig">
                <img alt="" src="/logo512.png"/>
                <div className="login-pig-shadow"/>
            </div>
            <h1 className="login-title">Tirelire</h1>
            <p className="login-tagline">Chaque pièce à sa place.</p>
        </div>
        <div className="login-frame">
            <form onSubmit={onSubmit}>
                <label htmlFor="login-email">Email</label>
                <input id="login-email" className="form-control" name="email" type="email" autoComplete="email" placeholder="vous@exemple.fr" autoFocus/>
                <label htmlFor="login-password">Mot de passe</label>
                <input id="login-password" className="form-control" name="password" type="password" autoComplete="current-password" placeholder="••••••••"/>
                <button type="submit" className="login-button" disabled={loading}>
                    { loading ? "Chargement…" : "Se connecter" }
                </button>
            </form>
            <div className="error-and-loading">{ errorMessage && <div className="error-message">{errorMessage}</div>}</div>
        </div>
    </div>
} 
export default Login
